import { IQuestionModel } from '@care-portals/api-interfaces';
import acneBelugaQuestions from './Initial/acneBeluga';
import acneArchived from './Initial/acne';

const acneQuestions: IQuestionModel[] = [
  ...acneBelugaQuestions,
  ...acneArchived
];

export default acneQuestions;
